import { ActivateExistingAccountRequest, ActivateExistingAccountResponse, ParsedActivationResponse } from "@models/account-activation.model";
import i18next from "i18next";

/**
 * Sendet eine Anfrage zur Überprüfung und Aktivierung eines bereits existierenden Kundenkontos.
 * @param data Die Daten für die Kontoaktivierung (Vorname, Nachname, Kundennummer, Geburtsjahr)
 * @returns Eine ParsedActivationResponse mit Information, ob das Konto existiert und ggf. Kundendaten
 */
export const activateExistingAccount = async (
  data: ActivateExistingAccountRequest
): Promise<ParsedActivationResponse> => {
  try {
    
    const response = await fetch("/api/user-exec", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        query: `fe_connect_customer_get_id("${data.firstname}","${data.lastname}",${data.customerNumber})`,
      }),
    });

    if (!response.ok) {
      throw new Error(i18next.t("api-errors.network-error"));
    }

    const result = await response.json() as ActivateExistingAccountResponse;

    if (!result.success) {
      throw new Error(result.message || i18next.t("api-errors.unknown-error"));
    }

    const responseText = typeof result.data === 'string' ? result.data : 
                         result.data?.result || "";
    
    const responseObject: Record<string, string> = {};
    
    if (responseText) {
      const pairs = responseText.split(',');
      pairs.forEach(pair => {
        const [key, ...valueParts] = pair.split(':');
        if (key && valueParts.length > 0) {
          const value = valueParts.join(':').trim();
          responseObject[key.trim()] = value;
        }
      });
    }
    
    console.log("Parsed response object:", responseObject);
    
    const customerId = responseObject['customer_id'];
    const customerNumber = responseObject['customer_number'];
    
    const exists = !!customerId && customerId !== "" && customerId !== "null" && customerId !== "undefined";
    
    console.log("Final result:", { customerId, customerNumber, exists });
    
    return {
      customer_id: customerId,
      customer_number: customerNumber,
      exists,
      customerData: responseObject
    };
  } catch (error) {
    console.error("Fehler bei der Kontoaktivierung:", error);
    throw error;
  }
}
